import type { Image, MediaBuiltSource } from '@velasca/types'
import { buildIntrinsicWidthSources } from './buildIntrinsicWidthSources'
import { setQueryParams } from './setQueryParams'

/**
 * Given a mobile image and a desktop image, return a list of image sources properties objects, to be fed into a Picture component.
 *
 */
export const getMediaSources = (
  mobileImage?: Image | null,
  desktopImage?: Image | null,
  id?: string,
): MediaBuiltSource[] => {
  let mediaSources: MediaBuiltSource[] = []

  if (mobileImage?.src) {
    mediaSources = [
      ...mediaSources,
      {
        id: `mobile-${id ?? mobileImage.src}`,
        sources: buildIntrinsicWidthSources({
          src: mobileImage.src,
          maxWidth: mobileImage.width,
        }),
        media: desktopImage?.src ? '(max-width: 767px)' : '',
        alt: mobileImage.alt ?? '',
        sizes: '100vw',
        imgSrc: setQueryParams(mobileImage.src, [
          { name: 'width', value: '30' },
        ]),
      },
    ]
  }

  if (desktopImage?.src) {
    mediaSources = [
      ...mediaSources,
      {
        id: `desktop-${id ?? desktopImage.src}`,
        sources: buildIntrinsicWidthSources({
          src: desktopImage.src,
          maxWidth: desktopImage.width,
        }),
        media: mobileImage?.src ? '(min-width: 768px)' : '',
        alt: desktopImage.alt ?? '',
        sizes: '100vw',
        imgSrc: setQueryParams(desktopImage.src, [
          { name: 'width', value: '30' },
        ]),
      },
    ]
  }

  return mediaSources
}
